import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../has.js";
import t from "../Logger.js";
import { pathToArray as n, getProperties as o } from "./utils.js";
var e,
    r = [];
var s = t.getLogger("esri.core.Accessor");

function c() {
  r = [];
}

function i(t) {
  void 0 !== e && e.onObservableAccessed(t);
}

var l = !1,
    f = !1;

function a(t, n, o) {
  if (l) return g(t, n, o);
  d(t);
  var e = n.call(o);
  return p(), e;
}

function u(t, n) {
  return a(void 0, t, n);
}

function g(t, n, o) {
  var e = l;
  l = !0, d(t);
  var r = null;

  try {
    r = n.call(o);
  } catch (c) {
    f && s.error(c);
  }

  return p(), l = e, r;
}

function d(t) {
  e = t, r.push(t);
}

function p() {
  var t = r.pop();
  e = r.length > 0 ? r[r.length - 1] : void 0, void 0 !== t && t.onTrackingEnd();
}

function m(t, n) {
  if (32 & n.flags) return;
  var o = f;
  f = !1, 64 & n.flags ? g(n, n.metadata.get, t) : A(t, n), f = o;
}

var h = [];

function A(t, o) {
  128 & o.flags || (o.flags |= 128, g(o, function () {
    var e = o.metadata.dependsOn || h;

    var _iterator = _createForOfIteratorHelper(e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _o = _step.value;
        if ("string" == typeof _o && -1 === _o.indexOf(".")) v(t, _o, !1);else {
          var _e = n(_o);

          for (var _n = 0, _o2 = t; _n < _e.length && null != _o2 && "object" == typeof _o2; ++_n) {
            _o2 = v(_o2, _e[_n], _n !== _e.length - 1);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }), o.flags &= -129);
}

function v(t, n, e) {
  var r = "?" === n[n.length - 1] ? n.slice(0, -1) : n;

  if (null != t.getItemAt || Array.isArray(t)) {
    var _n2 = parseInt(r, 10);

    if (!isNaN(_n2)) return Array.isArray(t) ? t[_n2] : t.getItemAt(_n2);
  }

  var s = o(t),
      c = null == s ? void 0 : s.properties.get(r);
  return c && (i(c), m(t, c)), e ? t[r] : void 0;
}

export { m as initializeDependencyTracking, c as resetGlobalTarget, a as runTracked, g as runTrackedNoThrow, u as runUntracked, i as trackAccess, A as trackExplicitDependencies };